'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("crmTicketService", function ($modal) {
  var editionPopinOptions = {
    controller: "ticketDocumentEditionPopinController",
    template: require("./ticketDocumentEditionPopin.html"),
    options: {
      width: 600
    }
  };
  return {
    /**
     *
     * @param $scope
     * @param ticket un ticket existant ou le "prototype" d'un ticket à créer (compteId doit être renseigné si on est pas sur un compte client)
     * @returns {*}
     */
    openEditionPopin: function openEditionPopin($scope, ticket) {
      return $modal.open({
        scope: $scope,
        controller: "ticketEditionPopinController",
        template: require("./editionConsultant/ticketEditionPopin.html"),
        vars: {
          edit: ticket != null && ticket.id ? true : false,
          ticket: ticket
        },
        options: {
          width: 1000
        }
      });
    },
    /**
     *
     * @param compteId
     * @param dateDebutTicket ex: new Date()
     * @param dateFinTicket ex: new Date()
     * @param titre
     * @param visibleClient
     * @param statutTicket
     * @param idAttribution
     * @param typeTicket
     * @returns {{typeTicket, visibleClient, statutTicket, compteId, titre, dateDebutTicket: Date, idAttribution, dateFinTicket: Date, echanges: *[]}}
     */
    createNewTicket: function createNewTicket(compteId, dateDebutTicket, dateFinTicket, titre, visibleClient, statutTicket, idAttribution, typeTicket) {
      return {
        compteId: compteId,
        dateDebutTicket: dateDebutTicket,
        dateFinTicket: dateFinTicket,
        titre: titre,
        visibleClient: visibleClient,
        statutTicket: statutTicket,
        idAttribution: idAttribution,
        typeTicket: typeTicket,
        echanges: []
      };
    },
    openDocumentEditionPopin: function openDocumentEditionPopin($scope, document) {
      return $modal.open(_.extend(editionPopinOptions, {
        scope: $scope,
        vars: {
          document: document
        }
      }));
    },
    openEditionClientPopin: function openEditionClientPopin($scope, ticket) {
      return $modal.open({
        scope: $scope,
        controller: "ticketEditionClientPopinController",
        template: require("./editionClient/ticketEditionClientPopin.html"),
        vars: {
          edit: ticket ? true : false,
          ticket: ticket
        },
        options: {
          width: 960
        }
      });
    },
    openChoixTicketPopin: function openChoixTicketPopin($scope, compteId) {
      return $modal.open({
        scope: $scope,
        controller: "choixTicketPopinController",
        template: require("./choixTicket/choixTicketPopin.html"),
        vars: {
          compteId: compteId
        },
        options: {
          width: 700
        }
      });
    },
    openDeplacerPopin: function openDeplacerPopin($scope, ticket) {
      return $modal.open({
        scope: $scope,
        controller: "ticketDeplacerPopinController",
        template: require("./editionConsultant/ticketDeplacerPopin.html"),
        vars: {
          ticket: ticket
        },
        options: {
          width: 700
        }
      });
    },
    openDemandeReouverturePopin: function openDemandeReouverturePopin($scope, ticket) {
      return $modal.open({
        scope: $scope,
        controller: "ticketDemandeReouverturePopinController",
        template: require("./demandeReouverture/ticketDemandeReouverturePopin.html"),
        vars: {
          ticket: ticket
        },
        options: {
          width: 900
        }
      });
    },
    openAnnulerDemandeReouverturePopin: function openAnnulerDemandeReouverturePopin($scope, ticket) {
      return $modal.open({
        scope: $scope,
        controller: "ticketAnnulerDemandeReouverturePopinController",
        template: require("./annulerDemandeReouverture/ticketAnnulerDemandeReouverturePopin.html"),
        vars: {
          ticket: ticket
        },
        options: {
          width: 900
        }
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ticket/crmTicketService.js
// module id = 2888
// module chunks = 13